// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1EIGp","consentsList":"PatientConsents_consentsList__1Fk7-","consentsListEmpty":"PatientConsents_consentsListEmpty__1-dE4"};